<template>
    <div class="create-page" @scroll.stop>
        <div class="create-modal" :style="{width:width+'px', height: height+'px'}">
            <img class="modal-close" @click="closeModal" src="@/assets/img/9-years/modal-close.png" alt="">
            <v-stage :style="{left:canvasLeft+'px'}" class="konvaStage" :config="configKonva" ref="konvaStage"  @mousedown="handleStageMouseDown" @touchstart="handleStageMouseDown">
                <v-layer>
                    <v-image :config="bgConfig"/>
                    <v-image v-for=" (item, idx) in userImages" :config="item" :key="'user-shape-'+idx" @dragmove="dragmove" @transform="transform" />
                    <v-group>
                        <v-transformer ref="transformer" :config="transformerConfig"/>
                        <v-image ref="removeChild" :config="removeChildConfig"/>
                    </v-group>
                </v-layer>
            </v-stage>
            <div class="shape-list">
                <!-- <img class="shape-list-bg" src="@/assets/img/9-years/elements-frame-bg.png" alt=""> -->
                <div class="shape-scroll-list">
                    <img class="game-shape-item" v-for="(img, key) in gameShapes" :src="img" :key="'game-shape-'+key" @click="addImage(key)" alt="">
                </div>
            </div>
            <img class="modal-bg" src="@/assets/img/9-years/modal-bg.png" alt="">
            <img class="save-image"  @click="saveImage" src="@/assets/img/9-years/save-image.png" alt="">
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import 'vant/lib/index.css'
import {  Toast, Button, Popup, Uploader, Dialog } from 'vant'
// import html2canvas from "html2canvas"
import VueCookie from "vue-cookie"
import VueKonva from 'vue-konva';
import Konva from 'konva';

Vue.use(VueKonva);
Vue.use(VueCookie)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Toast)
Vue.use(Dialog)
const mo=function(){
    try{
        // e.preventDefault();
        // console.log(e)
    }catch(err){
        console.log(err)
    }
    
};


export default {
    name: 'board',
    props:{
        width: [String, Number],
        height: [String, Number]
    },
    data(){
        return {
            // gameShapes:["//fcupload.happyelements.com/uploads/images/animal-newyear-2023/1.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/2.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/3.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/4.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/5.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/6.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/7.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/8.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/9.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/10.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/11.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/12.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/13.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/14.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/15.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/16.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/17.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/18.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/19.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/20.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/21.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/22.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/23.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/24.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/25.png","//fcupload.happyelements.com/uploads/images/animal-newyear-2023/26.png"],
            gameShapes:["//fcupload.happyelements.com/uploads/xxl-9-years-1/1.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/2.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/3.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/4.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/5.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/6.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/7.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/8.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/9.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/10.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/11.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/12.png","//fcupload.happyelements.com/uploads/xxl-9-years-1/13.png"],
            canvasLeft:0,
            userImages:[],
            configKonva: {
                width: 300,
                height: 300
            },
            bgConfig:{
                image:null,
                width: 300,
                height: 300*1.08
            },
            removeChildConfig:{
                name:"remove",
                x:0,
                y:0,
                rotation:0,
                scaleX:0,
                scaleY:0,
                width: 20,
                height: 20,
                image:null,
                visible: false,
                zIndex:999,
                offset:{
                    x:0,
                    y:30
                }
                
            },
            transformerConfig:{
                keepRatio:true,
            },
            selectedShapeName:"",
            uploading:false,
        }
    },
    created(){
        var canvasWidth = this.width*0.755;
        this.canvasLeft = this.width*0.129;
        var canvasHeight = canvasWidth*1.08;
        this.configKonva = {
            width: canvasWidth,
            height: canvasHeight
        }
        this.bgConfig.width = canvasWidth
        this.bgConfig.height = canvasHeight
        document.body.style.overflow='hidden';
        document.addEventListener("touchmove", mo, false);//禁止页面滑动
        var bgImage = new window.Image();
        bgImage.crossOrigin = 'Anonymous';
        bgImage.src = window.USER_CREATIVE_BG
        bgImage.onload = () => {
            this.bgConfig.image = bgImage;
        };
        var removeImage = new window.Image();        
        removeImage.crossOrigin = 'Anonymous';
        removeImage.src = "//fcupload.happyelements.com/uploads/image/20230112/273d100b7aad11cff3990101ff79feb0.png";
        removeImage.onload = () => {
            this.removeChildConfig.image = removeImage;
        };
    },
    destory(){
        document.body.style.overflow='';//出现滚动条
        document.removeEventListener("touchmove", mo, false);
    },
    methods:{
        addImage(key){
            var curDate = new Date
            var bgImage = new window.Image();
            bgImage.crossOrigin = 'Anonymous';
            bgImage.src = this.gameShapes[key]
            bgImage.onload = () => {
                this.userImages.push({
                    image:bgImage,
                    name:"image-"+curDate.getTime()+""+curDate.getMilliseconds(),
                    width:100,
                    height:100,
                    draggable: true,
                    remove:false
                })
            };
        },
        closeModal(){
            Dialog.confirm({
                message: '退出后当前内容不会保存，确认退出？',
            }).then(() => {
                document.body.style.overflow='';//出现滚动条
                document.removeEventListener("touchmove",mo,false);
                this.$emit("closed")
            });
        },
        handleTransformEnd(e) {
            const rect = this.userImages.find(
                (r) => r.name === this.selectedShapeName
            );
            // update the state
            rect.x = e.target.x();
            rect.y = e.target.y();
            rect.rotation = e.target.rotation();
            rect.scaleX = e.target.scaleX();
            rect.scaleY = e.target.scaleY();

            // change fill
            rect.fill = Konva.Util.getRandomColor();
        },
        handleStageMouseDown(e) {
            // clicked on stage - clear selection
            if (e.target === e.target.getStage()) {
                this.selectedShapeName = '';
                this.updateTransformer();
                return;
            }

            // clicked on transformer - do nothing
            const clickedOnTransformer =
                e.target.getParent().className === 'Transformer';
            if (clickedOnTransformer) {
                return;
            }

                // find clicked rect by its name
            const name = e.target.name();
            if(name=="remove"){
                let transformerNode = this.$refs.transformer.getNode();
                let stage = transformerNode.getStage();
                let selectedNode = stage.findOne('.' + this.selectedShapeName);
                selectedNode.destroy()
                for(let i=0;i<this.userImages.length;i++){
                    if(this.userImages[i].name==this.selectedShapeName){
                        this.userImages[i].remove = true;
                    }
                }
            }
            const rect = this.userImages.find((r) => r.name === name);
            if (rect) {
                this.selectedShapeName = name;
                this.updateRemoveImagePosition(e);
                this.removeChildConfig.visible=true
            } else {
                this.selectedShapeName = '';
                this.removeChildConfig.visible=false
            }
            this.updateTransformer();
        },
        updateTransformer() {
            // here we need to manually attach or detach Transformer node
            const transformerNode = this.$refs.transformer.getNode();
            const stage = transformerNode.getStage();
            const { selectedShapeName } = this;

            const selectedNode = stage.findOne('.' + selectedShapeName);
            // do nothing if selected node is already attached
            if (selectedNode === transformerNode.node()) {
                return;
            }
            if (selectedNode) {
                // attach to another node
                transformerNode.nodes([selectedNode]);
            } else {
                // remove transformer
                transformerNode.nodes([]);
            }
        },
        transform(e){
            const rect = this.userImages.find(
                (r) => r.name === this.selectedShapeName
            );
            // update the state
            rect.x = e.target.x();
            rect.y = e.target.y();
            rect.rotation = e.target.rotation();
            rect.scaleX = e.target.scaleX();
            rect.scaleY = e.target.scaleY();
            this.updateRemoveImagePosition(e);
            // change fill
            rect.fill = Konva.Util.getRandomColor();
        },
        dragmove(e){
            const rect = this.userImages.find(
                (r) => r.name === this.selectedShapeName
            );
            // update the state
            rect.x = e.target.x();
            rect.y = e.target.y();
            rect.rotation = e.target.rotation();
            rect.scaleX = e.target.scaleX();
            rect.scaleY = e.target.scaleY();
            this.updateRemoveImagePosition(e);
            // change fill
            rect.fill = Konva.Util.getRandomColor();
        },
        updateRemoveImagePosition(e){
            let target = e.target;
            this.removeChildConfig.x=target.x();
            this.removeChildConfig.y=target.y();
            this.removeChildConfig.scaleX=target.scaleX();
            this.removeChildConfig.scaleY=target.scaleY();
            this.removeChildConfig.rotation=target.rotation();
        },
        downloadURI(uri, name) {
            var link = document.createElement('a');
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }, 
        saveImage(){
            this.selectedShapeName = "";
            this.removeChildConfig.visible=false
            this.updateTransformer()
            var count = 0;
            for(let i=0;i<this.userImages.length;i++){
                if(this.userImages[i].remove==false){
                    count++;
                }
            }
            if(count<1){
                Toast("您还未装扮哦~")
                return false;
            }
            setTimeout(()=>{
                let stage = this.$refs.konvaStage.getStage();
                var dataURL = stage.toDataURL({ pixelRatio: 3 });
                this.$emit("saveImage", dataURL)
            },20);
        }
    }
}
</script>
<style scoped>
.create-page{
    position: fixed;
    width:100vw;
    height:100vh;
    max-width: 900px;
    left: 0px;
    top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    background-color: rgba(0,0,0,0.65);
}
.create-modal{
    position: relative;
    z-index: 12;
}
.modal-close{
    width: 6%;
    position: absolute;
    right: 0px;
}
.save-image{
    width: 47.78%;
    position: absolute;
    right: 26.11%;
    bottom: 0%;
}
.konvaStage{
    position:absolute;
    top: 16.5%;
}
.shape-list{
    width: 75%;
    height: 10%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    bottom:14%;
}
.shape-scroll-list{
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0%;
    display: flex;
    align-items: center;
    overflow: scroll;
}
.game-shape-item{
    width: 15%;
    height: auto;
    margin: 1.5%;
}
</style>>